import React from 'react'
import BranchAvatar from '../../../../../BranchSwitcher/BranchAvatar'

interface OrgAvatarProps {
  name?: string
  short?: string
  color: string
  size?: 'sm' | 'md'
}

const OrgAvatar: React.FC<OrgAvatarProps> = ({ name, short, color, size = 'md' }) => (
  <BranchAvatar
    name={name}
    short={short}
    color={color}
    className={`um-refactor__org-avatar um-refactor__org-avatar--${size}`}
  />
)

export default OrgAvatar
